import Vue from 'vue'
import Vuex from 'vuex'

import auth from './modules/auth'
import account from './modules/account'
import catalogs from './modules/catalogs'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {

  },
  mutations: {

  },
  actions: {

  },
  modules: {
    auth,
    account,
    catalogs
  }
})
